module.exports = __webpack_public_path__ + "img/no-holidays.bb1a3c78.svg";